/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';

export const SIDEBAR_SETTINGS = {
  DISPLAY_UID: 'assetId',
  DISPLAY_ASSET_ALIAS_NAME: 'assetAlias',
  DISPLAY_DIMENSION: 'DISPLAY_DIMENSION',
};

export const AssetWithAlertCountPropType = PropTypes.shape({
  assetId: PropTypes.string,
  assetAlias: PropTypes.string,
  assetAlertCount: PropTypes.number,
  dimensions: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
});

export const AssetsWithAlertCountPropType = PropTypes.arrayOf(
  PropTypes.shape({
    totalRecords: PropTypes.number,
    assets: PropTypes.arrayOf(AssetWithAlertCountPropType),
  })
);

export const MONITOR_SIDE_NAV_BASE_CLASS_NAME = 'monitor--side-nav';

export const MAX_ITEMS_PAGE = 100;

export const SEPARATOR = '--';
